import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
// import PaymentRealizedDetail from 'components/Tvendo/Bank/DataMaster/Payments/PaymentRealizedDetail/PaymentRealizedDetail';
import ShowPayment from 'components/Tvendo/Bank/Operations/Payments/PendingPaymentDetail/ShowPayment';

export default function () {
  const { pathname } = useLocation();

  const paymentType = useMemo(() => {
    if (pathname.includes('pago-recibidos')) return 'RECEIVED';
    return 'ACCOMPLISHED';
  }, [pathname]);

  return <ShowPayment paymentType={paymentType} />;
}
